<template>
  <div class="news-panel">
    <!-- Card Destaque com animação -->
    <transition
      name="fade-slide"
      mode="out-in"
    >
      <b-card
        key="highlight"
        class="mb-3 p-4 highlight-card"
        no-body
      >
        <div class="d-flex flex-column flex-md-row align-items-center">
          <img
            src="./bot.gif"
            class="img-fluid rounded mb-3 mb-md-0 mr-md-3"
            style="max-height: 200px;"
          >
          <div>
            <h3 class="text-primary">
              {{ highlight.title }}
            </h3>
            <p>{{ highlight.description }}</p>
            <b-button
              :href="highlight.url"
              variant="primary"
            >
              {{ highlight.cta }}
            </b-button>
          </div>
        </div>
      </b-card>
    </transition>

    <!-- Grid de Cards Menores -->
    <b-row>
      <transition-group
        name="fade"
        tag="div"
        class="d-flex flex-wrap w-100"
      >
        <b-col
          v-for="(card, index) in cards"
          :key="card.title"
          md="6"
          class="mb-3"
        >
          <b-card
            v-if="!card.video"
            :title="card.title"
            :img-src="card.image"
            img-top
          >
            <b-card-text>{{ card.description }}</b-card-text>
            <b-button
              v-if="card.cta"
              :href="card.url"
              :variant="card.variant || 'outline-primary'"
              size="sm"
            >
              {{ card.cta }}
            </b-button>
          </b-card>

          <!-- Card de Vídeo -->
          <b-card
            v-else
            :title="card.title"
          >
            <div class="embed-responsive embed-responsive-16by9 mb-2">
              <iframe
                class="embed-responsive-item"
                :src="card.video"
                allowfullscreen
              />
            </div>
            <b-card-text>{{ card.description }}</b-card-text>
          </b-card>
        </b-col>
      </transition-group>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'NewsPanel',
  data() {
    return {
      highlight: {
        title: '🚀 Nova funcionalidade: Agente IA para o SAC!',
        description:
            'A nossa inteligencia entende as mensagens e aúdios dos clientes e responde automaticamente de forma conversacional no Whatsapp.',
        image: '/bot.gif',
        cta: 'clique aqui para ativar essa novidade!',
        url: '/bot',
      },
      cards: [
        {
          title: '🚀 Nova Central de Atendimento no ar!',
          description:
              'Gerencie conversas do WhatsApp em tempo real, filtre atendimentos, busque por nome ou número e atenda seus clientes com agilidade em uma interface moderna e intuitiva.',
          image: '',
          cta: 'Acessar Nova Central',
          url: '/chat',
        },
        {
          title: 'Como usar o novo Agente',
          description:
              'Veja em menos de 1 minuto como o novo assistente da ManyConvert pode transformar seu atendimento.',
          video: 'https://www.youtube.com/embed/SEU_VIDEO_ID',
        },
        // {
        //   title: 'Dica da Semana',
        //   description: 'Use tags para organizar seus atendimentos e ganhar agilidade!',
        //   variant: 'outline-info',
        // },
        // {
        //   title: 'Parcerias',
        //   description: 'Indique um e-commerce parceiro e ganhe bônus exclusivos.',
        //   variant: 'success',
        //   cta: 'Indicar agora',
        // },
      ],
    }
  },
}
</script>

  <style scoped>
  .highlight-card {
    background-color: #f4f8fb;
    border-left: 5px solid #00cfe8;
  }

  .fade-slide-enter-active,
  .fade-slide-leave-active {
    transition: all 0.4s ease;
  }
  .fade-slide-enter,
  .fade-slide-leave-to {
    opacity: 0;
    transform: translateY(10px);
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: all 0.3s ease;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
    transform: scale(0.98);
  }
  </style>
